export type ReadonlyAddTaskEndpoints = {
    readonly AddUpdateTask: string;
    readonly CheckTaskAccess: string;
    readonly GetTasks: string;
    readonly GetTasksById: string;
    readonly GetTotalTasksById: string;
    readonly AddUpdateSubTask : string;
    readonly SubTaskIRN : string;
    readonly DeleteTask : string;
    readonly DeleteSubTask : string;
    readonly GetSubTasksById : string;
    readonly SearchTasks : string;
    readonly GetLastPONumberbyTaskSubTask : string;
    readonly GetLastWONumberbyTaskSubTask : string; 
    readonly sendMail : string; 
    readonly addUpdatePurchaseOrders : string; 
    readonly GetTasksForExport: string;
    readonly GetLevelAllmultiple: string; 
    readonly GetAllTenancyOnSiteLevel: string;  
    readonly addUpdateUserSiteConnection: string;  
    readonly DeleteTaskAction : string;
    readonly updateTaskSubTaskActionTaken : string; 
    readonly gettaskDescription : string; 
    readonly getTaskDescriptionExport : string;
    readonly AddActionTakenTask: string;
    readonly AddActionTakenSubTask: string;
    readonly addUpdatePOAttachment : string;
    readonly addUpdateWorkOrders : string; 
    readonly confidentialTaskSubTask : string;
    readonly UpdateEmbdocumentDetails:string;
    readonly GetUplodedFileForTask:string;
    readonly UpdateTaskFileNameEmbd:string;
    readonly   DownloadFile:string;
    readonly DeleteEmbdFile:string;
    readonly GetTaskDescById: string;
    readonly Refine: string;
    readonly CheckDuplicates: string;
  };
  
  const controller = 'api/Tasks'
  const purchaseord= 'api/PurchaseOrder'
  const subTaskController = 'api/SubTask'

  
  const AddTaskEndpoints: ReadonlyAddTaskEndpoints = {
    AddUpdateTask: `${controller}/AddUpdateTasks`,
    GetTasks: `${controller}/GetTasks`,
    GetTasksById : `${controller}/GetTasksById`,
    GetTotalTasksById : `${controller}/GetTotalTasksById`,
    AddUpdateSubTask : `${subTaskController}/AddUpdateSubTasks`,
    SubTaskIRN : `${subTaskController}/GetTotalSubTasksById`,
    GetSubTasksById : `${subTaskController}/GetSubTasksById`,
    DeleteTask: `api/Tasks/DeleteTasks`,
    DeleteSubTask: `api/SubTask/DeleteSubTasks`,//`api/SubTask`,
    SearchTasks: `${controller}/SearchTasks`,
    GetLastPONumberbyTaskSubTask: `${controller}/GetLastPONumberbyTaskSubTask`,
    GetLastWONumberbyTaskSubTask: `${controller}/GetLastWONumberbyTaskSubTask`, 
    sendMail: `${controller}/SendMailTaskSubTask`, 
    addUpdatePurchaseOrders: `${purchaseord}/AddUpdatePurchaseOrder`,
    GetTasksForExport: `${controller}/GetTasksForExport`,
    GetLevelAllmultiple: `${controller}/GetLevelAllmultiple`,  
    GetAllTenancyOnSiteLevel: `${controller}/GetAllTenancyOnSiteLevel`, 
    addUpdateUserSiteConnection: `api/Sites/AddUpdateUserSiteConnection`,
    DeleteTaskAction: `api/Tasks/DeleteTasksActionTaken`,
    updateTaskSubTaskActionTaken: `${controller}/UpdateTasksSubTaskActiontaken`,
    gettaskDescription: `${controller}/GetAllTaskDescription`, 
    getTaskDescriptionExport: `${controller}/TaskDescriptionForExport`,
    AddActionTakenTask:`${controller}/AddActionTakenTask`,
    AddActionTakenSubTask:`${subTaskController}/AddActionTakenSubTask`,
    addUpdatePOAttachment: `${purchaseord}/AddUpdatePOAttachment`,
    addUpdateWorkOrders: `${purchaseord}/AddUpdateWorkOrder`,
    confidentialTaskSubTask: `${controller}/AddTaskConfidential`,
    UpdateEmbdocumentDetails:`${controller}/UplodeEmbdocument`,
    GetUplodedFileForTask:`${controller}/GetTaskSubtaskEmdDocumentData`,
    UpdateTaskFileNameEmbd:`${controller}/UpdateFileNameForEmbd`,
    DownloadFile:`${controller}/DownloadFile`,
    DeleteEmbdFile:`${controller}/DeleteEmbdFile`,
    GetTaskDescById : `${controller}/GetTaskDescriptionById`,
    CheckTaskAccess: 'api/tasks/check-access',
    Refine: 'api/TaskAssistant/Refine',
    CheckDuplicates: 'api/TaskAssistant/CheckDuplicates'
  };
    
  export { AddTaskEndpoints };
  